import { UpcomingListPage } from '@/pages/inspection/upcoming/UpcomingListPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const upcomingSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(25),
	scope: z.enum(['mine', 'all']).default('mine'),
	sort: z.enum(['asc', 'desc']).default('desc'),
});

export const Route = createFileRoute('/_authenticated/_app/inspection/upcoming/')({
	component: UpcomingListPage,
	validateSearch: upcomingSearchSchema,
});
